<template>
    <div v-if="site && value">
        <inc-warranty
            v-model     = "component.showDialog"
            :warrenties = "incident.warrenties"
            :component  = "component.selected"
        />

        <div class="component-label primary--text">
            <div class="component-zoom" v-if="zoomAllowed">
                <a @click = "onZoom">
                    <v-icon size="20" color="primary">mdi-loupe</v-icon>
                </a>
            </div>
            {{ title }}
        </div>

        <div class="component-box lm-border">
            <div class="component-all primary--text" v-if="selected && selected.length > 1 && isWarrantyRelevant">
                <v-checkbox
                    v-model = "warranty"
                    :ripple = "false"
                    class   = "component-checkbox"
                    @click  = "onSelectAll"
                    hide-details
                    dense
                />

                <div class="component-font primary--text">{{ $t('inc.edit.invoice.allComponents') }}</div>
                <v-spacer />

                <div class="component-date-all">
                    <f-date-picker
                        v-model       = "warrantyDate"
                        :time         = "false"
                        :hide-details = "true"
                        class         = "primary--text"
                        @change       = "onInput"
                        dense
                    />
                </div>
            </div>
            <div style="overflow: auto" :style="'max-height: ' + height + 'px; '">
                <div v-for="(item,index) in value" :key="index">
                    <div class = "component-item">
                        <!-- Warranty Checkbox -->
                        <div>
                            <v-checkbox
                                v-model = "item.warranty"
                                :ripple = "false"
                                class   = "component-checkbox"
                                @click  = "onSelect(item)"
                                hide-details
                                dense
                            />
                        </div>
                        <!-- Warranty Checkbox -->

                        <div style="width: calc(100% - 178px);">
                            <a @click="onAction(item)">
                                <div class="v-flex w-100">
                                    <div class="action-icon">
                                        <i  :class="action(item).clazz" class="fa-sm" />
                                    </div>

                                    <div class="component-font" style="width: calc(100% - 25px);max-width: calc(100% - 25px);">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    {{ name (item) }}
                                                </div>
                                            </template>
                                            <span>{{ name (item) }}</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <!-- Warranty date -->
                        <div class="component-date">
                            <!-- ... if selected -->
                            <f-date-picker
                                v-if          = "item.warranty"
                                v-model       = "item.warrantyDate"
                                :time         = "false"
                                :hide-details = "true"
                                dense
                            />
                            <!-- ... if selected -->

                            <!-- ... if not selected -->
                            <div
                                v-if="!item.warranty"
                                class="component-date-not-selected"
                            >

                            </div>
                            <!-- ... if not selected -->
                        </div>
                        <!-- Warranty date -->

                        <div class="warranty-icon">
                            <a @click.stop="onWarranty (item.component)" v-if="hasWarranty(item.component)">
                                <i class="fas fa-exclamation-triangle error--text" />
                            </a>
                        </div>

                        <div class="remove-icon">
                            <a @click="onRemove(item)">
                                <v-icon color="error" size="18">mdi-delete</v-icon>
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <v-autocomplete
                dense
                multiple
                flat
                deletable-chips
                filled
                chips
                auto-select-first
                :items           = "items"
                item-value       = "component.id"
                item-text        = "component.fullname"
                background-color = "white"
                v-model          = "selected"
                @change          = "onChange"
                :rules           = "[ componetsRule ]"
                hide-selected
                style="margin-top: 3px"
                ref = "input"
            >
                <template v-slot:selection="">
                </template>

                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title class="component-title" v-html="data.item.component.name"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.component.groupname"></v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
        </div>
    </div>
</template>

<script>

import main        from "@/main";
import Inc         from "@/modules/inc/service/Inc";
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";
import IncWarranty from "@/modules/inc/warranty/IncWarranty.vue";

export default {
    name: "IncComponents",
    components: {
        IncWarranty,
        FDatePicker
    },

    props: {
        value: {
            type: Array,
        },

        site: {

        },

        incident: {

        },

        warranties: {

        },

        rules: {
            required: false,
            type: Array,
            default: function () {
                return [];
            }
        },

        status: {
            required: false,
            type: Object,
            default: function () {
                return null;
            }
        },

        zoomAllowed: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        height: {

        }
    },

    mounted() {
        this.selected = this.value.map(x => x.component.id);
    },

    watch: {
        warranties: {
            deep: true,
            handler: function () {
            }
        },

        value () {
            this.selected = this.value.map(x => x.component.id);
        }
    },

    data: () => ({
        warrantyDate : null,
        warranty     : false,
        type         : Inc.type,
        component: {
            selected: null,
            showDialog: false,
        },

        selected: [],
        actions: [
            {
                action: "UNDEFINED",
                clazz : "fas fa-question red--text",
                text  : "inc.components.actions.UNDEFINED"
            },
            {
                action: "REPAIR",
                clazz : "fas fa-tools",
                text  : "inc.components.actions.REPAIR"
            },
            {
                action: "CHANGE",
                clazz : "fas fa-exchange-alt",
                text  : "inc.components.actions.CHANGE"
            }
        ]
    }),

    computed: {
        items () {
            if (!this.site || !this.site.type) {
                return [];
            }

            const list = this.$store.getters.components[this.site.type.groupTd];
            if (!list) {
                return [];
            }

            let components = [];
            list.forEach (component => {
                const edited = this.value.find(c => c.component.id === component.id);

                components.push ({
                    component   : component,
                    action      : this.getAction(component.id),
                    warrantyDate: edited ? edited.warrantyDate : null,
                    warranty    : edited ? edited.warranty     : null
                });
            });

            return components;
        },

        title () {
            if (!this.site.type) {
                return null;
            }

            return "Komponenten/Gewährleistung " + this.site.type.name + " Anlage " + this.site.fabricNo;
        },

        isWarrantyRelevant () {
            return this.incident.typeId !== this.type.falsealarm
                && this.incident.typeId !== this.type.maintenance
                && this.incident.typeId !== this.type.emergency
                && this.incident.typeId !== this.type.assessmentcost
                && this.incident.typeId !== this.type.guardcost
                && this.incident.typeId !== this.type.assessmentinvoice
                ;
        },
    },

    methods: {
        onZoom () {
            this.$emit("zoom");
        },

        componetsRule (value)  {
            if (Inc.step.canceled(this.status)) {
                return true;
            }

            if (!this.items) {
                return true;
            }

            if ((!value || value.length === 0) && (this.status && this.status.type === 'T')) {
                return this.$t("rules.required");
            }

            if ((!value || value.length === 0) && !this.status) {
                return main.i18n().t("rules.required");
            }

            let components = [];
            this.selected.forEach(id => components.push(this.items.find (item => item.component.id === id)));

            if (components.length > 0) {
                if (components.some(c => c && c.action === 'UNDEFINED')) {
                    return main.i18n().t("inc.rules.component");
                }
            }

            return true;
        },

        hasWarranty (component) {
            if (!this.warranties || !this.warranties.components)
                return false;
            return this.warranties.components.find(c => c.id === component.id)
        },

        name (item) {
            let name = item.component.name + " " + this.$t(this.action(item).text);
            if (name.length > 43) {
                return name.substr (0, 43) + "...";
            }
            return name;
        },

        action (item) {
            return this.actions.find(a => a.action === item.action);
        },

        getAction (item) {
            const hits = this.value.filter(x => x.component.id === item)
            if (hits.length > 0) {
                return hits[0].action
            }

            return "UNDEFINED"
        },

        onSelect (component) {
            if (!component.warranty) {
                this.warrantyDate = null;
            }

            if (component.warranty && !component.warrantyDate) {
                component.warrantyDate = this.warrantyDate;
            }
        },

        onSelectAll () {
            this.value.forEach(c => {
                c.warranty = this.warranty;
                if (c.warranty && !c.warrantyDate) {
                    c.warrantyDate = this.warrantyDate;
                }
            });
        },

        onAction (item) {
            switch (item.action) {
                case "UNDEFINED":
                    item.action = "REPAIR";
                    break;
                case "REPAIR":
                    item.action = "CHANGE";
                    break;
                case "CHANGE":
                    item.action = "UNDEFINED";
                    break;
            }

            this.emit();
        },

        onRemove (item) {
            const index = this.selected.findIndex(x => x === item.component.id)
            if (index >= 0) {
                this.selected.splice(index, 1)
            }

            this.emit();
        },

        onInput (value) {
            this.value.forEach(c => {
                if (c.warranty && !c.warrantyDate) {
                    c.warrantyDate = value;
                }
            });
        },

        onChange () {
            if (!this.selected) return;
            this.emit();
        },

        onWarranty (component) {
            console.log("warranty", this.warranties)
            this.component.selected = component;
            this.component.showDialog = true;
        },

        emit () {
            let components = [];
            this.selected.forEach(id => components.push(this.items.find (item => item.component.id === id)));
            this.$emit("input", components);
        },
    }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

.component-title {
    font-size: 15px!important;
    font-weight: normal!important;
}


</style>

<style lang="scss" scoped>

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: var(--v-primary-base)!important;
    font-size: 15px;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: white!important;
}

.component-label {
    font-size: 11px;
    margin-bottom: 2px;
    position: relative;
}

.component-zoom {
    position: absolute;
    right: 4px;
    top: -6px;
}

.component-box {
    min-height: 159px;
    min-width: 340px;
}

.component-all {
    max-width: calc(100% - 0px);
    height: 36px;
    border-bottom-style: solid;
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    display: flex;
}

.component-date {
    min-width: 90px;
    width: 90px;
    padding-left: 10px;
    margin-top: -2px;
}

.component-date-all {
    margin-top: -2px;
    padding-top: 0;
    min-width: 80px;
    width: 80px;
    margin-right: 58px;
}

.component-font {
    font-size: 15px;
    padding-top: 7px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.component-select {
    padding-top: 2px;
    width: calc(100% - 90px);
}

.component-checkbox {
    margin-left: 4px;
    margin-top: 2px;
}

.component-item {
    max-width: calc(100% - 0px);
    height: 36px;
    border-bottom-style: solid;
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    display: flex;
}


:deep(input) {
    min-height: 28px;
}
.component-date-not-selected {
    text-align: center!important;
    padding-top: 3px;
    padding-bottom: 3px;
}

.component-date-not-selected i {
    margin-top: 4px;
}


.action-icon {
    width: 25px;
    min-width: 25px;
    margin-top: 5px;
}

.action-text {
    margin-left: 10px;
    text-align: center;
}

.remove-icon {
    width: 25px;
    min-width: 25px;
    margin-top: 5px;
    padding-left: 4px;
    padding-right: 4px;
}

.warranty-icon {
    width: 25px;
    min-width: 25px;
    margin-top: 7px;
    padding-left: 6px;
    padding-right: 4px;
}

</style>